export interface Image {
  id: string;
  url: string;
  title: string;
  description?: string;
  width: number;
  height: number;
  price: number;
  tags: string;
}

export interface User {
  id: string;
  name: string;
  email: string;
  profilePicture?: string;
  googleId?: string; // Para identificar usuarios de Google
  userId?: number; // ID del usuario en el backend
}

export interface CartItem {
  image: Image;
  quantity: number;
}

export interface CartPackage {
  type: 'individual' | 'pack5' | 'pack10';
  images: Image[];
  price: number;
}

export enum AuthStatus {
  LOADING = 'loading',
  AUTHENTICATED = 'authenticated',
  UNAUTHENTICATED = 'unauthenticated',
}